import React, { Component } from 'react'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import './gp-web-plans-thank-you-page.css'
import { BACK_POST_MESSAGE } from '../../../actions'

export class GPWebPlansThankYouPage extends Component {
  constructor(props) {
    super(props)
  }

  backPostMessage(e) {
    e.preventDefault();
    
    this.props.handleAction(BACK_POST_MESSAGE);
  }

  render() {
    const { t, router } = this.props

    const {params} = router ? router : {};
    const {email, price, currency} = params ? params : {};

    return (
      <div className="wrapper">

        <div className="modal-content">

          <h1 className="title">{t('GP_PLANS_THANK_YOU_HEADER')}</h1>

          <p className='description'>{t('GP_PLANS_THANK_YOU_DESCRIPTION', {email})}</p>

          <hr className='divider'/>

          <p className='product'>{t('GP_CHK_PLAN_1_TITLE')}</p>

          <div className='thank-you-footer'>
            <p>{t('GP_ORDER_TOTAL')}</p>
            <span>{currency}{price}</span>
          </div>

        </div>

        <a className='continue' onClick={this.backPostMessage.bind(this)}>{t('GP_PLANS_THANK_YOU_CONTINUE')}</a>

      </div>
    )
  }
}

const mapStateToProps = (state) => ({
})

const mapDispatchToProps = dispatch => ({
  handleAction: (type, payload) => dispatch({ type, payload }),
})

export default connect(mapStateToProps, mapDispatchToProps)(
  translate()(GPWebPlansThankYouPage),
)



// WEBPACK FOOTER //
// ./src/containers/pages/gp-web-plans-thank-you-page/gp-web-plans-thank-you-page.js